import { useMatches } from 'react-router-dom';
import { IndexPath } from '@/Config/app/router/index.path';

export const useCurrentIndexPath = (): string | undefined => {
  const matches = useMatches();

  // Look from the deepest route up for a handle.indexPath
  for (let i = matches.length - 1; i >= 0; i -= 1) {
    const handle = matches[i].handle as { indexPath?: typeof IndexPath } | undefined;
    if (handle?.indexPath) {
      return handle.indexPath.toString();
    }
  }

  return undefined;
};

export const useCheckContainsIndexPath = (indexPath: string): boolean => {
  const matches = useMatches();

  for (let i = 0; i < matches.length; i += 1) {
    const handle = matches[i].handle as { indexPath?: typeof IndexPath } | undefined;
    if (handle?.indexPath?.toString() == indexPath) {
      return true;
    }
  }
  return false;
};
